/**
 * A helper class to provide a simple mechanism for sorting a predefined array
 */
export class SimpleSorter<T extends number | string | symbol> {
    private readonly rankingMap: Record<T, number | undefined>;

    public constructor(arr: T[]) {
        this.rankingMap = arr.reduce(
            (carry, item, index) => {
                carry[item] = index;
                return carry;
            },

            {} as Record<T, number | undefined>,
        );
    }

    public sort(arr: T[]): T[] {
        return arr.sort(this.sortCompare.bind(this));
    }

    public mappedSort<A>(arr: A[], mapper: (item: A) => T): A[] {
        return arr.sort((itemA: A, itemB: A) => this.sortCompare(mapper(itemA), mapper(itemB)));
    }

    public sortCompare(itemA: T, itemB: T): number {
        const aVal = this.rankingMap[itemA] ?? null;
        const bVal = this.rankingMap[itemB] ?? null;

        if (aVal === null && bVal === null) {
            return 0;
        } else if (aVal === null) {
            return 1;
        } else if (bVal === null) {
            return -1;
        }
        return aVal - bVal;
    }
}
